module.exports = __webpack_public_path__ + "img/CAL-UHF_Impulse.65fdd34f07dd5920ee52503cb6a80c93.avif";